// extracted by mini-css-extract-plugin
module.exports = {"container":"buttons-burger-container"};